<template>
  <div>
    <div class="idea">
      <div class="idea-header">
        <div class="title">
          {{ $t('ideas.idea.title.idea') }} #{{ idea.id }}
        </div>
        <div class="remain">{{ idea.period }}</div>
      </div>
      <div v-if="idea.bought" class="idea-positions">
        <div
          v-for="(position, index) of idea.positions"
          :key="index"
          class="position mb-0 f-between"
        >
          <p class="mb-0 mr-3">{{ position.ticker }}</p>
          <p
            class="mb-0"
            :class="
              getPriceChangeClass(position.targetPrice - position.openPrice)
            "
          >
            {{ getRecomendation(position.openPrice, position.targetPrice) }}
          </p>
        </div>
      </div>
      <div
        v-if="idea.bought"
        v-html="description"
        class="idea-description"
      ></div>
      <buy-key v-else class="idea-buy">
        <p class="text mb-0">
          Эта инвестидея является платной, чтобы посмотреть,
          <br />
          <a
            href="https://t.me/RDVPREMIUMbot"
            target="_blank"
            rel="noreferrer"
            class="link"
            >купите подписку</a
          >
        </p>
      </buy-key>
      <div
        v-for="(factorType, typeIndex) in idea.factors"
        :key="typeIndex"
        class="idea-factor"
      >
        <h3 class="title mb-0">
          {{ $t(`ideas.idea.factors.${typeIndex}.name`) }}
        </h3>
        <div v-for="(factor, index) in factorType" :key="index" class="factor">
          <div class="header f-between">
            <h5 class="name mb-0">
              {{ $t(`ideas.idea.factors.${typeIndex}.${index}`) }}
            </h5>
            <div class="influence f-between">
              <p class="mb-0 mr-2">{{ $t('ideas.idea.factor.influence') }}:</p>
              <p
                class="mb-0 font-weight-bold"
                :class="getPriceChangeClass(factor.influence)"
              >
                {{ factor.influence }}
              </p>
            </div>
          </div>
          <p class="content mb-0">{{ factor.content }}</p>
          <a v-if="factor.reviewLink" :href="factor.reviewLink" class="link">
            {{ $t('ideas.idea.factor.article') }}
          </a>
        </div>
      </div>
      <div v-if="idea.risks && idea.risks.length" class="idea-factor">
        <h3 class="title mb-0">
          {{ $t('ideas.idea.risks') }}
        </h3>
        <div v-for="(risk, index) in idea.risks" :key="index" class="factor">
          <div class="header">
            <h5 class="name mb-0">
              {{ risk.title }}
            </h5>
          </div>
          <p class="content mb-0">{{ risk.content }}</p>
          <a v-if="risk.reviewLink" :href="risk.reviewLink" class="link">
            {{ $t('ideas.idea.factor.article') }}
          </a>
        </div>
      </div>
      <div v-if="idea.socialCredits" class="idea-social d-inline-flex">
        <div class="arrow"><i-arrow /></div>
        <div class="points" :class="getPriceChangeClass(idea.socialCredits)">
          {{ idea.socialCredits }}
        </div>
        <div class="arrow up"><i-arrow /></div>
      </div>
      <div class="idea-analyst" v-if="idea.analyst">
        <div class="name">
          {{ $t('ideas.analyst.author') }}:
          {{ idea.analyst.name[$i18n.locale] }}
        </div>
        <div class="params d-flex">
          <div v-if="idea.analyst.socialCredits" class="param">
            {{ $t('ideas.analyst.trust') }}
            {{ idea.analyst.socialCredits }}
          </div>
          <div v-if="idea.analyst.accuracy" class="param">
            {{ $t('ideas.analyst.accuracy') }} {{ idea.analyst.accuracy }}%
          </div>
        </div>
      </div>
    </div>
    <div class="information"></div>
    <div class="connected"></div>
  </div>
</template>

<script>
import calcPrice from '@/utils/mixins/calcPrice'
import iarrow from '@/components/icons/arrow'
import buyKey from '@/components/library/buyKey'

const md = require('markdown-it')({
  html: true,
  linkify: true,
  typographer: true,
})

export default {
  mixins: [calcPrice],
  computed: {
    idea() {
      return this.deleteEmptyFactors(this.$store.getters['ideas/getFullIdea'])
    },
    description() {
      return this.idea.description
        ? this.formatDecription(this.idea.description)
        : ''
    },
  },
  mounted() {
    this.$store.dispatch('ideas/loadFullIdea', { id: this.$route.params.idea })
    this.unsubscribe = this.$store.subscribeAction({
      after: (action) => {
        if (action.type === 'user/logout') {
          this.$store.dispatch('ideas/loadFullIdea', {
            id: this.$route.params.idea,
          })
        }
      },
    })
  },
  beforeDestroy() {
    this.unsubscribe()
  },
  methods: {
    getRecomendation(openPrice, targetPrice) {
      return this.$t(
        'ideas.positions.' + (targetPrice > openPrice ? 'buy' : 'sell')
      )
    },
    deleteEmptyFactors(idea) {
      let filteredIdea = Object.assign(idea, {})
      for (let factor in filteredIdea.factors) {
        let hasFactors = false
        if (filteredIdea.factors[factor]) {
          for (let infactor in filteredIdea.factors[factor]) {
            if (
              !filteredIdea.factors[factor][infactor] ||
              !filteredIdea.factors[factor][infactor].content ||
              !filteredIdea.factors[factor][infactor].influence
            )
              delete filteredIdea.factors[factor][infactor]
            else hasFactors = true
          }
          if (!hasFactors) delete delete filteredIdea.factors[factor]
        }
      }
      return filteredIdea
    },
    formatDecription(description) {
      let content = description.replace(/[\\]/gm, '')
      content = md.render(content)
      return content
    },
  },
  components: {
    'i-arrow': iarrow,
    'buy-key': buyKey,
  },
}
</script>

<style lang="scss">
.idea {
  max-width: 558px;
  margin: 0 auto;
  padding: 38px 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
  color: #000000;

  &-header .remain,
  &-description,
  &-buy .text,
  &-factor .content,
  &-factor .name,
  &-factor .link {
    line-height: 24px;
    font-size: 16px;
  }

  &-header {
    border-bottom: 1px solid #c2c2d6;
    padding-bottom: 11px;
    .title {
      font-style: normal;
      font-weight: bold;
      font-size: 32px;
      line-height: 40px;
    }
    .remain {
      margin-top: 10px;
    }
  }

  &-positions {
    width: 40%;
  }

  &-buy {
    padding-top: 20px;
    padding-bottom: 12px;
    .text {
      text-align: center;
      .link {
        color: $primary-color2;
      }
    }
  }

  &-factor {
    padding: 32px;
    background: #f6f6fa;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    .title {
      line-height: 32px;
      font-size: 24px;
    }
    .factor {
      .header {
        .influence {
          line-height: 16px;
          font-size: 12px;
          color: #9d9dbc;
        }
      }
      .content {
        margin-top: 8px;
      }
      .link {
        display: block;
        margin-top: 4px;
        color: $primary-color2;
      }
    }
  }

  &-social {
    padding-top: 8px;
    .points {
      font-weight: bold;
      margin: 0 5px;
    }
  }

  &-analyst {
    border-top: 1px solid #c2c2d6;
    padding-top: 10px;
    .params {
      margin-top: 10px;
      .param {
        line-height: 16px;
        font-size: 12px;
        &:not(.param:last-of-type) {
          margin-right: 12px;
        }
      }
    }
  }
}

@media (max-width: 576px) {
  .idea {
    padding: 20px 15px;
    gap: 10px;
    &-header {
      .title {
        font-size: 28px;
      }
    }
    &-buy {
      padding: 0;
      padding-bottom: 10px;
    }
    &-description {
      font-size: 14px;
    }
  }
}

#app[data-theme='dark'] {
  .idea {
    color: #d6d6d6;
    &-factor {
      background: #222222;
      .influence {
        color: #9d9dbc;
      }
    }
  }
}
</style>
